// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/style.scss
// module id = 1071
// module chunks = 65